/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoUserLogin } from '../../models/dto-user-login';
import { LoginResponse } from '../../models/login-response';

export interface IdentityControllerLoginPassport$Params {
      body: DtoUserLogin
}

export function identityControllerLoginPassport(http: HttpClient, rootUrl: string, params: IdentityControllerLoginPassport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerLoginPassport.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: LoginResponse;
      }>;
    })
  );
}

identityControllerLoginPassport.PATH = '/identity/session';
